import { ColorsEnum } from "../../../../../../../core/et3-theme/colors";

const ALPHA_DESCRIPTION_SOFT = "1F";

export const DESCRIPTION_WIDTH = 430;
export const DESCRIPTION_BOX_HEIGHT = 224;
export const DESCRIPTION_COLUMN_HEIGHT = 286;
export const DESCRIPTION_HEADER_HEIGHT = 42;
export const DESCRIPTION_HEADER_PADDING = 16;
export const DESCRIPTION_HEADER_FONT_SIZE = 16;
export const DESCRIPTION_HEADER_GAP = 8;
export const DESCRIPTION_STATUS_ICON_SIZE = 22;
export const DESCRIPTION_BODY_HEIGHT = 170;
export const DESCRIPTION_BODY_PADDING = 16;
export const DESCRIPTION_BODY_FONT_SIZE = 17;
export const DESCRIPTION_BODY_LINE_HEIGHT = 1.6;
export const DESCRIPTION_SOLVE_HEIGHT = 56;
export const DESCRIPTION_SOLVE_GAP = 12;
export const DESCRIPTION_STATUS_CHIP_HEIGHT = 22;
export const DESCRIPTION_STATUS_CHIP_PADDING = 8;
export const DESCRIPTION_STATUS_CHIP_FONT_SIZE = 10;
export const DESCRIPTION_STATUS_CHIP_RADIUS_CSS = "5px";
export const DESCRIPTION_STATUS_CHIP_LETTER_SPACING = 0.5;
export const DESCRIPTION_SOFT_PENDING = `${ColorsEnum.davysGrey}${ALPHA_DESCRIPTION_SOFT}`;
export const DESCRIPTION_SOFT_APPROVED = `${ColorsEnum.seaGreen}${ALPHA_DESCRIPTION_SOFT}`;
export const DESCRIPTION_SOFT_REJECTED = `${ColorsEnum.red}${ALPHA_DESCRIPTION_SOFT}`;
